import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";

const RootRedirect = () => {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "superadmin" ? "/empresas" : "/consulta"} replace />;
};

const Page = ({ children, roles }) => (
  <ProtectedRoute roles={roles}>
    <Layout>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<RootRedirect />} />
            <Route path="/consulta" element={<Page roles={["superadmin", "admin", "editor", "viewer"]}><Dashboard /></Page>} />
            <Route path="/empresas" element={<Page roles={["superadmin"]}><Companies /></Page>} />
            <Route path="/usuarios" element={<Page roles={["superadmin", "admin"]}><Users /></Page>} />
            <Route path="/configuracion" element={<Page roles={["superadmin", "admin"]}><Settings /></Page>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
